module.exports = __webpack_public_path__ + "static/media/thumb_pano.0b09f18b.svg";